import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory,useParams } from "react-router-dom";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import { toast } from "react-toastify";

function DiscountModal({ closeDialog }) {
  const dispatch = useDispatch();
  const {id} = useParams();
  const history = useHistory();
  const discountState = useSelector(({ discount }) => discount.discount);

  function handleNavigateDiscount(data) {
    if (!id) {
      toast.error("There is an unsaved discount. Please save it first.");
      return;
    }
    history.push(`/discount/${data.id}/edit`);
    closeDialog();
  }

  let tableColumns = [
    {
      name: "Title",
      selector: (row) => row.title,
      cell: (row) => (
        <button type="button" 
        onClick={() => handleNavigateDiscount(row)} 
        className="flex justify-center items-center">
          {row?.title}
        </button>
      ),
      sortable: true,
      center: false,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      center: false,
    },
    {
      name: "Method",
      selector: (row) => row.method,
      sortable: true,
      center: false,
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
      center: false,
    }
  ];

  const sampleDiscounts = [
    { id: 1, title: "Summer Sale", status: "Active", method: "Automatic", type: "Seasonal" },
    { id: 2, title: "Free Shipping Promo", status: "Inactive", method: "Code", type: "Shipping" },
    { id: 3, title: "Buy One Get One", status: "Active", method: "Code", type: "BOGO" },
    { id: 4, title: "Clearance Event", status: "Expired", method: "Automatic", type: "Clearance" },
    { id: 5, title: "Black Friday", status: "Active", method: "Automatic", type: "Seasonal" },
    { id: 6, title: "Cyber Monday", status: "Active", method: "Code", type: "Seasonal" },
    { id: 7, title: "Holiday Deal", status: "Active", method: "Code", type: "Holiday" },
    { id: 8, title: "Loyalty Discount", status: "Active", method: "Automatic", type: "Loyalty" },
    { id: 9, title: "New Customer Offer", status: "Inactive", method: "Code", type: "Welcome" },
    { id: 10, title: "Refer a Friend", status: "Active", method: "Code", type: "Referral" },
    { id: 11, title: "Flash Sale", status: "Active", method: "Automatic", type: "Flash" },
    { id: 12, title: "Spring Clean Sale", status: "Active", method: "Code", type: "Seasonal" },
    { id: 13, title: "Mid-Year Clearance", status: "Expired", method: "Automatic", type: "Clearance" },
    { id: 14, title: "Anniversary Promo", status: "Active", method: "Automatic", type: "Special Event" },
    { id: 15, title: "Weekend Deal", status: "Inactive", method: "Code", type: "Limited Time" },
    { id: 16, title: "Midnight Madness", status: "Active", method: "Automatic", type: "Flash" },
    { id: 17, title: "Cart Abandon Offer", status: "Active", method: "Code", type: "Behavioral" },
    { id: 18, title: "VIP Member Promo", status: "Active", method: "Automatic", type: "Loyalty" },
    { id: 19, title: "Back to School", status: "Expired", method: "Code", type: "Seasonal" },
    { id: 20, title: "Bundle Deal", status: "Active", method: "Automatic", type: "Bundle" },
    { id: 21, title: "Weekend Flash Sale", status: "Active", method: "Code", type: "Flash" },
    { id: 22, title: "Birthday Discount", status: "Active", method: "Automatic", type: "Personalized" },
    { id: 23, title: "Student Discount", status: "Inactive", method: "Code", type: "Eligibility" },
    { id: 24, title: "Military Discount", status: "Active", method: "Code", type: "Eligibility" },
    { id: 25, title: "End of Season", status: "Expired", method: "Automatic", type: "Clearance" },
    { id: 26, title: "Fall Favorites", status: "Active", method: "Code", type: "Seasonal" },
    { id: 27, title: "Freebie Friday", status: "Active", method: "Code", type: "BOGO" },
    { id: 28, title: "Thanksgiving Deal", status: "Active", method: "Automatic", type: "Holiday" },
    { id: 29, title: "Christmas Special", status: "Active", method: "Code", type: "Holiday" },
    { id: 30, title: "New Year Offer", status: "Active", method: "Code", type: "Holiday" },
    { id: 31, title: "Welcome 2025", status: "Active", method: "Automatic", type: "New User" },
    { id: 32, title: "Test Promo 1", status: "Inactive", method: "Code", type: "Test" },
    { id: 33, title: "Test Promo 2", status: "Active", method: "Automatic", type: "Test" },
    { id: 34, title: "Test Promo 3", status: "Expired", method: "Code", type: "Test" },
    { id: 35, title: "Limited Drop", status: "Active", method: "Automatic", type: "Limited Edition" },
    { id: 36, title: "App Exclusive", status: "Active", method: "Code", type: "Platform" },
    { id: 37, title: "Weekend Madness", status: "Inactive", method: "Code", type: "Flash" },
    { id: 38, title: "Season Starter", status: "Active", method: "Automatic", type: "Seasonal" },
    { id: 39, title: "Free Shipping Weekend", status: "Active", method: "Code", type: "Shipping" },
    { id: 40, title: "Mega Saver", status: "Active", method: "Automatic", type: "Bundle" }
  ];
  

  return (
    <div
      style={{
        minHeight: sampleDiscounts === 0 ? 150 : 400,
        maxHeight: 500,
        overflowY: "scroll",
        scrollbarWidth: "none" /* Firefox */,
        WebkitOverflowScrolling: "touch" /* Smooth scrolling for iOS */,
        WebkitScrollbar: "none",
      }}
    >
      <CommonDataTable
        headerColumns={tableColumns}
        gridData={discountState?.modal_data || []}
        // loading={loading}
        noDataMessage="There are no products!"
        disableExtendRowFullWidth={true}
        hideFooter={true}
        pagination={false}
        noAction
      />
    </div>
  );
}

export default DiscountModal;
